<p-toast [breakpoints]="{ '420px': { width: '100%', right: '0', left: '0' } }"></p-toast>
<div class="rate-mainouter custom-promo-code">
  <div class="create-offer-heading promo-heading">
    <h4>{{ isEdit ? 'Edit Promo Code Details' : (isOfferId ? 'View Promo Code Details' : 'Create Promo Code') }}</h4>

  </div>
  <div class="main-bg">
    <form [formGroup]="createPromoCodeForm">
      <div class="main-group">

        <div class="offer-outer" *ngIf="roleName === userRoles.SUPER_ADMIN">
          <div class="edit-specify">
            <div class="create-offer-text">
              <p>Please specify the category for which you'd like to create the promo code.<span class="custom-star">
                  *</span></p>
            </div>

          </div>

<div class="grid" [class.cursor-none]="isOfferId">
            <div class="col-3">
              <div class="offer-apply" (click)="selectCategory(false)">
                <div class="application-outer">
                  <p-radioButton inputId="trucklots" [value]="0" formControlName="selectcategory" />
                  <h3>Trucklots</h3>
                </div>
                <p>This promo code will be applicable to all the companies.</p>
              </div>
            </div>
            <div class="col-3">
              <div class="offer-apply" (click)="selectCategory(true)">
                <div class="application-outer">
                  <p-radioButton inputId="parkinglots" [value]="1" formControlName="selectcategory" />
                  <h3>Parking Lots</h3>
                </div>
                <p>This promo code will be applicable to the selected parking lots.</p>
              </div>
            </div>
          </div>
        </div>
        <hr *ngIf="roleName === userRoles.SUPER_ADMIN" class="custom-line" />
        <div class="offer-summary-outer">

          <div class="basic-text">
            <h4>Basic Information</h4>
          </div>
          <div class="grid">

            <div class="col-5">
              <div class="group-outer">
                <label for="offerCode">Promo Code <span class="custom-star"> *</span></label>
                <input type="text" pInputText placeholder="Enter Promo Code" formControlName="offerCode" maxlength="15"
                  (input)="onOfferCodeInput()" />
                <div
                  *ngIf="createPromoCodeForm.get('offerCode')?.hasError('required')  && (createPromoCodeForm.get('offerCode')?.dirty || createPromoCodeForm.get('offerCode')?.touched)">
                  <div class="validation-error"> This field is required*</div>
                </div>
              </div>
            </div>
            <div class="col-5">
              <div class="group-outer">
                <label for="offerDiscount">Discount % <span class="custom-star"> *</span></label>
                <input pInputText placeholder="Enter Discount %" (keypress)="onKeyPressAllowTwoDigitAfterPoint($event)"
                  formControlName="offerDiscount" />
                <div
                  *ngIf="createPromoCodeForm.get('offerDiscount')?.hasError('required')  && (createPromoCodeForm.get('offerDiscount')?.dirty || createPromoCodeForm.get('offerDiscount')?.touched)">
                  <div class="validation-error"> This field is required*</div>
                </div>
                <div
                  *ngIf="createPromoCodeForm.get('offerDiscount')?.hasError('lessThanHundred') && (createPromoCodeForm.get('offerDiscount')?.dirty || createPromoCodeForm.get('offerDiscount')?.touched)">
                  <div class="validation-error"> Discount cannot exceed 100%</div>
                </div>

              </div>
            </div>
            <div class="col-5">
              <div class="group-outer">
              <label for="startDate">Start Date<span class="custom-star"> *</span></label>
              <div class="date-arrow">
                <p-calendar inputId="calendar-24h" [showTime]="false" #calendarTopStartDateRef [minDate]="calculatedDate" [readonlyInput]="true"
                  dateFormat="M dd, yy" placeholder="Select Date" formControlName="startDate"
                  [class.no-pointer-events]="createPromoCodeForm.get('startDate')?.disabled"  styleClass="pointer-cursor"/>
                <img src="assets/images/date-calender.png" (click)="openTopStartDateCalendar()"  [class.no-pointer-events]="createPromoCodeForm.get('startDate')?.disabled" alt="calender"/>

                  <div
                    *ngIf="createPromoCodeForm.get('startDate')?.hasError('required')  && (createPromoCodeForm.get('startDate')?.dirty || createPromoCodeForm.get('startDate')?.touched)">
                    <div class="validation-error"> This field is required*</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-5">
              <div class="group-outer">
                <label for="endDate">End Date<span class="custom-star"> *</span></label>
                <div class="date-arrow">
                  <p-calendar inputId="calendar-24h" #calendarTopEndDateRef [showTime]="false" [minDate]="calculatedDate"
                    [readonlyInput]="true" dateFormat="M dd, yy" placeholder="Select Date" formControlName="endDate"
                    styleClass="pointer-cursor"
                    [class.no-pointer-events]="createPromoCodeForm.get('endDate')?.disabled" />

                  <img src="assets/images/date-calender.png"  (click)="openTopEndDateCalendar()" [class.no-pointer-events]="createPromoCodeForm.get('endDate')?.disabled" alt="calender"/>
                  <div
                    *ngIf="createPromoCodeForm.get('endDate')?.hasError('required')  && (createPromoCodeForm.get('endDate')?.dirty || createPromoCodeForm.get('endDate')?.touched)">
                    <div class="validation-error"> This field is required*</div>
                  </div>
                </div>
              </div>
            </div>

          </div>

<div class="visibility-outer">
            <div class="basic-text">
              <h4>Visibility Option<span class="custom-star"> *</span></h4>
            </div>
            <div class="public-outer">
              <div class="public-radio"
                [class.no-pointer-events]="createPromoCodeForm.get('offerVisibility')?.disabled">
                <p-radioButton inputId="private" [value]="offerVisbility.private"
                  (onClick)="selectOfferVisibility(offerVisbility.private)" formControlName="offerVisibility" id="private"/>
                <label for="offerVisibility" class="ml-2">Private</label>
              </div>
              <div class="public-radio" [class.no-pointer-events]="createPromoCodeForm.get('offerVisibility')?.disabled">
              <p-radioButton inputId="public" [value]="offerVisbility.public" (onClick)="selectOfferVisibility(offerVisbility.public)" formControlName="offerVisibility" />
              <label for="offerVisibility" class="ml-2" id="public">Public</label>
              </div>
            </div>
            <div
            *ngIf="createPromoCodeForm.get('offerVisibility')?.hasError('required')  && (createPromoCodeForm.get('offerVisibility')?.dirty || createPromoCodeForm.get('offerVisibility')?.touched)">
            <div class="validation-error"> This field is required*</div>
          </div>
            <div class="grid">
              <div class="col-5">
                <div class="group-outer top-margin">
                  <label for="bookingType">Booking Type<span class="custom-star"> *</span></label>
                  <div class="date-arrow">
                    <p-dropdown placeholder="Select Booking Type" formControlName="bookingType"
                      [options]="bookingTypeOptions" optionLabel="label" optionValue="value" />
                    <img [class.no-pointer-events]="createPromoCodeForm.get('bookingType')?.disabled"
                      src="assets/images/fill-dropdown.svg" alt=""/>
                    <div
                      *ngIf="createPromoCodeForm.get('bookingType')?.hasError('required')  && (createPromoCodeForm.get('bookingType')?.dirty || createPromoCodeForm.get('bookingType')?.touched)">
                      <div class="validation-error"> This field is required*</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid">
              <div class="col-5">
                <div class="group-outer">
                  <label for="offerSummary">Summary <span class="custom-star"> *</span></label>
                  <textarea pInputTextarea cols="30" placeholder="Type here:" formControlName="offerSummary"
                    maxlength="50" style="resize: none"></textarea>
                  <div
                    *ngIf="createPromoCodeForm.get('offerSummary')?.hasError('required')  && (createPromoCodeForm.get('offerSummary')?.dirty || createPromoCodeForm.get('offerSummary')?.touched)">
                    <div class="validation-error"> This field is required*</div>
                  </div>
                </div>
              </div>
              <div class="col-5">
                <div class="group-outer">
                  <label for="offerDescription">Description <span class="custom-star"> *</span></label>
                  <textarea pInputTextarea cols="30" placeholder="Type here:" formControlName="offerDescription"
                    maxlength="150" style="resize: none"></textarea>
                  <div
                    *ngIf="createPromoCodeForm.get('offerDescription')?.hasError('required')  && (createPromoCodeForm.get('offerDescription')?.dirty || createPromoCodeForm.get('offerDescription')?.touched)">
                    <div class="validation-error"> This field is required*</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

</div>
      </div>

      <hr class="custom-line" *ngIf="!categoerRadioCheck()" />
      <div class="assign-rate" *ngIf="!categoerRadioCheck()">
        <div class="assign-rate-inner">
          <h4>Select parking lots to which you want to assign the promo code:<span class="custom-star"> *</span></h4>
          <div class="select-inner" *ngIf="!isOfferId">

            <ul>
              <li class="active-select" (click)="checkAll(false)">
                <button>Deselect All</button>
              </li>
              <li class="active-select" (click)="checkAll(true)">
                <button>Select All</button>
              </li>
            </ul>
            <div class="selectall-inner">
              <div class="email-search">
                <input type="text" pInputText placeholder="Search parking lot by name, city or state"
                  formControlName="searchParkingLot" />
                <p-button styleClass="p-button ml-3" label="Search" (onClick)="getParkingLots(companyId)"></p-button>
              </div>
            </div>

          </div>

        </div>
        <div class="parking-rate-scroll" *ngIf="!categoerRadioCheck()"
          [class.no-record-outer]="parkingLotsData?.length === 0">
          <div class="grid" formArrayName="parkingLots">
            <div class="col-6 lg:col-4 xl:col-2" *ngFor="let data of parkingLotsData; let i = index">
              <div class="select-parking" [ngClass]="{'pointer-cursor': !parkingLotsArray.at(i).disabled, 'default-cursor': parkingLotsArray.at(i).disabled}"
                 (click)="toggleCheckbox(data,i)">
                <p-checkbox [binary]="true" inputId="bianry" [checked]="parkingLotsArray.at(i).value"
                  [formControlName]="i" (onChange)="toggleCheckbox(data, i)" [class.no-pointer-events]="createPromoCodeForm.get('i')?.disabled" />
                <div class="parking-inner">
                  <img [src]="data.companyLogoPath ? data.companyLogoPath : dummy" alt=""/>
                  <h4>{{data.name}}</h4>
                  <p>{{data.address}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="no-record-found" *ngIf="parkingLotsData?.length === 0">
            <p>No Record Found</p>
          </div>
        </div>
      </div>
      <div class="submit-outer cancel-btn" *ngIf="!isOfferId">
        <p-button styleClass="p-button p-button-outlined" (onClick)="redirectToListing()" label="Cancel"></p-button>
        <p-button styleClass="p-button ml-3" label="Create" type="submit" (onClick)="createPromoCode()"></p-button>
      </div>
      <div class="submit-outer cancel-btn"
      *ngIf="!(promoOfferData?.categoryView === 'Trucklots' && (roleName === userRoles.PARKING_MANAGER || roleName === userRoles.PARKING_OWNER)) && roleName !== userRoles.SUPER_ADMIN && !router.url.includes('create-promo-code')">
      <p-button *ngIf="isEdit" styleClass="p-button p-button-outlined" (onClick)="redirectToListing()" label="Cancel"></p-button>
      <p-button styleClass="p-button search-button ml-3" (onClick)="isEdit ? editPromoCode() : editPromoRoute()"
        [label]="isEdit ? 'Save' : 'Edit'"></p-button>

    </div>
    <div *ngIf="!router.url.includes('create-promo-code') && roleName === userRoles.SUPER_ADMIN"
      class="submit-outer cancel-btn">
      <p-button *ngIf="isEdit" styleClass="p-button p-button-outlined" (onClick)="redirectToListing()" label="Cancel"></p-button>
      <p-button styleClass="p-button search-button ml-3" (onClick)="isEdit ? editPromoCode() : editPromoRoute()"
        [label]="isEdit ? 'Save' : 'Edit'"></p-button>
    </div>

    </form>

  </div>
</div>
